import { render, staticRenderFns } from "./AbortQueueModal.vue?vue&type=template&id=63ff5622&scoped=true"
import script from "./AbortQueueModal.vue?vue&type=script&lang=js"
export * from "./AbortQueueModal.vue?vue&type=script&lang=js"
import style0 from "./AbortQueueModal.vue?vue&type=style&index=0&id=63ff5622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff5622",
  null
  
)

export default component.exports